import { formatDate } from "../../shared/CommonFunctions";

export interface ComponentHeaderProps {
  dateCreated?: string;
  userCreated?: string;
  editPath?: string;
  showEdit?: boolean;
  backPath?: string;
  showBack?: boolean;
  label?: string;
}

export default function componentProviderHeader({ dateCreated, userCreated, label }: ComponentHeaderProps) {
  return (
    <>
      <div className="w-full border-0 shadow-none comp-header">
        <div className="flex justify-between items-center w-full mb-3 border-purple border-2 text-purple font-bold flex-wrap header-height">
          <div>
            <h4 className="text-purple flex items-center">
              <span className="pl-1 mx-1 mt-0"></span>
              <span>{label}</span>
            </h4>
          </div>
          <div>
            {userCreated != null && (
              <>
                <span className="user-icon icon-spec ml-3 pr-1!"></span> <span> {userCreated}</span>
                <span className="time-stamp icon-spec pr-1!"></span> <span className="mr-2">{formatDate(dateCreated!)}</span>
              </>
            )}
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
}
